// TODO: don't calculate position based on specific arrow style
import { Position } from "../../types";
import { Dimensions } from "./types";

const POPUP_ARROW_WIDTH = 8;

/**
 * Gets the position of the popup relative to the anchor.
 * The position will be bounded within the window in the opposite dimension
 * e.g. position: top will be bounded within the left & right of the window
 */

export function getPopupPosition(
  position: Position,
  {
    anchor,
    popup,
    boundingRect
  }: {
    anchor: Dimensions;
    popup: Dimensions;
    boundingRect: Dimensions;
  }
) {
  const topShift = (popup.height - anchor.height) / 2;
  const leftShift = (popup.width - anchor.width) / 2;
  const minLeftBound = -(anchor.left - boundingRect.left);
  const maxLeftBound =
    boundingRect.width - (anchor.left - boundingRect.left) - popup.width;
  const minTopBound = -(anchor.top - boundingRect.top);
  const maxTopBound =
    boundingRect.height - (anchor.top - boundingRect.top) - popup.height;

  const positionToUse =
    position === "auto" ? getAutoPosition({ boundingRect, anchor }) : position;

  switch (positionToUse) {
    case "left":
      return {
        top: getBoundedPosition({
          minBound: minTopBound,
          desired: -topShift,
          maxBound: maxTopBound
        }),
        left: -popup.width - POPUP_ARROW_WIDTH
      };

    case "top":
      return {
        top: -popup.height - POPUP_ARROW_WIDTH,
        left: getBoundedPosition({
          minBound: minLeftBound,
          desired: -leftShift,
          maxBound: maxLeftBound
        })
      };

    case "right":
      return {
        top: getBoundedPosition({
          minBound: minTopBound,
          desired: -topShift,
          maxBound: maxTopBound
        }),
        left: anchor.width + POPUP_ARROW_WIDTH
      };

    case "bottomRight":
      return {
        top: anchor.height + POPUP_ARROW_WIDTH,
        left: getBoundedPosition({
          minBound: minLeftBound,
          desired: anchor.width / 2 - POPUP_ARROW_WIDTH,
          maxBound: maxLeftBound
        })
      };

    case "bottomLeft":
      return {
        top: anchor.height + POPUP_ARROW_WIDTH,
        left: getBoundedPosition({
          minBound: minLeftBound,
          desired: anchor.width / 2 - popup.width + POPUP_ARROW_WIDTH,
          maxBound: maxLeftBound
        })
      };

    case "topRight":
      return {
        top: -popup.height - POPUP_ARROW_WIDTH,
        left: getBoundedPosition({
          minBound: minLeftBound,
          desired: anchor.width / 2 - POPUP_ARROW_WIDTH,
          maxBound: maxLeftBound
        })
      };

    case "topLeft":
      return {
        top: -popup.height - POPUP_ARROW_WIDTH,
        left: getBoundedPosition({
          minBound: minLeftBound,
          desired: anchor.width / 2 - popup.width + POPUP_ARROW_WIDTH,
          maxBound: maxLeftBound
        })
      };

    case "bottom":
    default:
      return {
        top: anchor.height + POPUP_ARROW_WIDTH,
        left: getBoundedPosition({
          minBound: minLeftBound,
          desired: -leftShift,
          maxBound: maxLeftBound
        })
      };
  }
}

function getBoundedPosition({
  minBound,
  desired,
  maxBound
}: {
  minBound: number;
  desired: number;
  maxBound: number;
}) {
  return Math.max(minBound, Math.min(desired, maxBound));
}

function getAutoPosition({
  boundingRect,
  anchor
}: {
  boundingRect: Dimensions;
  anchor: Dimensions;
}): Position {
  const anchorMidPoint = {
    x: anchor.left + anchor.width / 2,
    y: anchor.top + anchor.height / 2
  };

  const boundingRectMidPoint = {
    x: boundingRect.left + boundingRect.width / 2,
    y: boundingRect.top + boundingRect.height / 2
  };

  if (anchorMidPoint.x < boundingRectMidPoint.x) {
    if (anchorMidPoint.y < boundingRectMidPoint.y) {
      return "bottomRight";
    }
    return "topRight";
  } else if (anchorMidPoint.y < boundingRectMidPoint.y) {
    return "bottomLeft";
  }
  return "topLeft";
}
